"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _index = _interopRequireDefault(require("./index.style"));
// eslint-disable-next-line react/display-name
const TextField = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    children,
    className = '',
    ...others
  } = props;
  const classes = (0, _index.default)();
  return /*#__PURE__*/_react.default.createElement(_TextField.default, (0, _extends2.default)({
    ref: ref
  }, others, {
    className: (0, _clsx.default)(classes.root, others.error && classes.textFieldError, className)
  }));
});
var _default = exports.default = TextField;